import React from "react";
import i18n from "@microdoing/shared/i18n";
import { Box } from "app/components/common";
import OnboardingWebInfo from "app/components/common/Onboarding/OnboardingWebInfo";
import { useSelector } from "react-redux";
import { getSignupRequesting } from "@microdoing/shared/services/signup/selectors";
import OnboardingWebBody from "app/components/common/Onboarding/OnboardingWebBody";

const EmailImage = require("../../../../assets/images/Group.png");

interface IProps {
  body: React.ReactElement;
  isButtonDisable: boolean;
  goNext: () => void;
}

const WebSetupEmail = ({ body, isButtonDisable, goNext }: IProps) => {
  const requesting = useSelector(getSignupRequesting);

  return (
    <Box flex={1} justifyContent="center" backgroundColor="neutral.white">
      <Box variant="webOnboarding" flexDirection="row">
        <OnboardingWebInfo image={EmailImage} />
        <OnboardingWebBody
          title={i18n.t("informations")}
          subTitle={i18n.t("complete-profile")}
          body={<>{body}</>}
          textButton={i18n.t("next")}
          onPressButton={goNext}
          isButtonDisable={isButtonDisable}
          isButtonLoading={requesting}
        />
      </Box>
    </Box>
  );
};

export default WebSetupEmail;
